import {useEffect, useState} from 'react';
import {Box, Button, Typography} from '@mui/material';

import {AppContent, ContentRow} from '../../../styled/components';
import {ActionsRow, ContentRowHeader, FormRow, ProvinceContainer} from './province-form.styles';
import {getProvince} from '../api-service';

const Field = ({label, value}) => (
  <Box sx={{flex: 1, minWidth: 200}}>
    <Typography
      variant="caption"
      color="textSecondary"
      sx={{display: 'block', textTransform: 'uppercase', letterSpacing: 0.4}}
    >
      {label}
    </Typography>
    <Typography variant="body1" sx={{wordBreak: 'break-word'}}>
      {value && String(value).trim() !== '' ? value : '—'}
    </Typography>
  </Box>
);

function ProvinceShow({provinceId, onEdit, onList}) {
  const [province, setProvince] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    getProvince(provinceId)
      .then((data) => {
        if (!data) {
          throw new Error(`State ${provinceId} not found`);
        }
        setProvince(data);
      })
      .catch((err) => setError(err.message || 'Error loading state'))
      .finally(() => setLoading(false));
  }, [provinceId]);

  if (loading) {
    return (
      <AppContent>
        <ContentRow>
          <Typography variant="h5" component="h1">Loading state...</Typography>
        </ContentRow>
      </AppContent>
    );
  }

  if (error || !province) {
    return (
      <AppContent>
        <ContentRow>
          <Typography variant="h5" component="h1" color="error">
            {error || 'State not found'}
          </Typography>
        </ContentRow>
      </AppContent>
    );
  }

  return (
    <AppContent>
      <ContentRow sx={ContentRowHeader}>
        <Typography variant="h5" component="h1">{`States / ${province.name || ''}`}</Typography>
        <Box sx={ActionsRow}>
          <Button variant="outlined" onClick={onList}>States list</Button>
          <Button variant="contained" onClick={onEdit}>Edit</Button>
        </Box>
      </ContentRow>
      <ContentRow>
        <Box sx={ProvinceContainer}>
          <Box sx={FormRow}>
            <Field label="State Name" value={province.name}/>
            <Field label="State Code" value={province.code}/>
          </Box>
          <Box sx={FormRow}>
            <Field label="Country" value={province.countryName}/>
          </Box>
        </Box>
      </ContentRow>
    </AppContent>
  );
}

export default ProvinceShow;
